// extracted by mini-css-extract-plugin
export var borderRadius = "_70-4";
export var large = "_70-3";
export var logoContainer = "_70-0";
export var nameLogo = "_70-2";
export var small = "_70-1";